import { string, func } from 'prop-types'

import styles from './Navigation.scss';
import logo from '../img/logo_small.png';
import Total from './Total';

Navigation.propTypes = {
    onClick: func.isRequired,
    totalPrice: string.isRequired
}

function Navigation({ totalPrice, onClick }) {
    return (
        <nav>
            <div className={styles.container}>
                <div className={styles.left}>
                    <img src={logo} alt="BeachTravels small logo"/>
                    <h1>Praia da Rocha - Booking</h1>
                </div>
                <Total totalPrice={totalPrice} onClick={onClick} />
            </div>
        </nav>
    )
}

export default Navigation





// WEBPACK FOOTER //
// ./app/components/Navigation.js